/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Caption_DeskInputs */

const en_hero_caption_desk = /** @type {(inputs: Hero_Caption_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage is where Tomorrow works on it.`)
};

/**
* | output |
* | --- |
* | "Backstage is where Tomorrow works on it." |
*
* @param {Hero_Caption_DeskInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hero_caption_desk = /** @type {((inputs?: Hero_Caption_DeskInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Caption_DeskInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hero_caption_desk(inputs)
});